import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuardService implements CanActivate {
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot) {
    const queries = Object.keys(route.queryParams || {})
      .map(key => `${key}=${route.queryParams[key]}`)
      .join('&');
    window.location.href = route.data['url'] + (queries ? '?' : '') + queries;
    return false;
  }
}
